const article = `
{settings}
document.title: Bakom kulisserna på M-krisen: Den interna kritiken växer
og.title: Bakom kulisserna på M-krisen: Den interna kritiken växer
og.image: http://quickshot.imgix.net/m-krisen-bakom-kulisserna/AKB_TOPP1.jpg?w=1000&auto=format
og.description: Hon är liberalen som fick leda partiet i konservativ riktning. Fri invandring-förespråkaren som gjorde avbön och ville stänga gränserna. Under hennes ledning har Moderaterna tappat en fjärdedel av sina väljare och internt växer missnöjet när både kärnväljare och nymoderater överger partiet.
og.url: http://pejl.svt.se/m-krisen-bakom-kulisserna/
siteCatalyst.name: m-krisen-bakom-kulisserna
siteCatalyst.category: lyxartikel
{}

[+page]
luft:-48
{.bild}
fil: m-krisen-bakom-kulisserna/AKB_TOPP1.jpg
storlek: xl
foto: Stina Stjernkvist / TT 
{}
rubrik: Bakom kulisserna på M-krisen: Den interna kritiken växer

Ingress: Hon är liberalen som fick leda partiet i konservativ riktning. Fri invandring-förespråkaren som gjorde avbön och ville stänga gränserna. Under hennes ledning har Moderaterna tappat en fjärdedel av sina väljare och internt växer missnöjet när både kärnväljare och nymoderater överger partiet. Anna Kinberg Batra (M) går nu igenom sin svåraste prövning hittills.

mellanrubrik: [ 13 Januari 2017 | tid ]
Januariresan var planerad sedan länge. Ett par gånger om året åker Anna Kinberg Batra och den övriga partiledningen på "internat", inte sällan utomlands. Denna gång gick resan till Amsterdam.
Opinionschefen Per Nilsson var med för att redovisa sina staplar och diagram. Slutsatserna var dystra. Partiet gick kräftgång i opinionen, toppnoteringarna våren 2016 kändes långt borta. Än värre var det förtroendet för partiledaren.
Den samlade analysen kring bordet var att de väljare som ville se en borgerlig regering helt enkelt inte trodde att hon och Moderaterna menade allvar. De lät ju Stefan Löfven regera vidare. Partiet uppfattades som tandlöst och fegt.
De åtta toppmoderaterna var överens - något måste göras. 

{.bild}
fil: m-krisen-bakom-kulisserna/AKB_PARTILEDNING.jpg
storlek: wide
bildtext: Delar av Moderaternas partiledning: Anna Kinberg Batra, Ulf Kristersson, Peter Danielsson, Elisabeth Svantesson, Jessica Polfjärd och Tomas Tobé. Saknas på bilden gör presschefen Linda Norberg och stabschefen Johan Andréasson. 
foto: Jessica Gow/TT 
{}

Men att man skulle landa i ett närmare samarbete med Sverigedemokraterna var långtifrån självklart. Anna Kinberg Batra hade länge hållit emot. Bara att föreslå en gemensam alliansbudget utan att hela alliansen var med på det, riskerade att stjälpa hela alliansbygget. Att ta ytterligare ett steg och öppna upp för förhandlingar med Sverigedemokraterna i riksdagens utskott var minerad mark. Hur skulle hon egentligen uppfattas som ledare för alliansen - som stark eller som svag?
Den ekonomisk-politiske talespersonen Ulf Kristersson var tveksam och presenterade flera olika alternativ. Partisekreterare Tomas Tobé var mer övertygad. Äntligen skulle man visa partikamrater och väljare att man övergett den avskydda decemberöverenskommelsen på riktigt. Partiets andre vice ordförande Elisabeth Svantesson var inne på samma linje. Väljarna brydde sig inte om Moderaternas politiska förslag så länge man inte visade att man ville fälla regeringen. Det ständiga fokuset på det politiska spelet måste få ett slut. 
Sist men inte minst - pressen på Centerpartiet i regeringsfrågan skulle öka, de hade ju kommit irriterande lindrigt undan. 
Partiledaren höll som alltid korten tätt intill kroppen i diskussionen men beslutet var till sist hennes att fatta. 
När partiledningen med Anna Kinberg Batra i spetsen landade på Arlanda på söndagskvällen trodde de att en efterlängtad "game-changer" var på väg. 

{.bild}
fil: m-krisen-bakom-kulisserna/AKB_VALJS.jpg
storlek: lwide
bildtext: Den 10 januari 2015 valdes Anna Kinberg Batra formellt till ny partiordförande under Moderaternas extrastämma.
foto: Henrik Montgomery / TT
{}


mellanrubrik: [ 10:e januari 2015 | tid ]

Stekarlåten "Something new" dånade ur högtalarna när Anna Kinberg Batra intog scenen den där dagen i januari 2015 i den halvtrista lokalen på ett hotell vid Friends Arena. Moderaterna hade just valt sin sextonde ordförande, den första kvinnan. Men den uppfordrande låten till trots var "något nytt" inte huvudbudskapet. Ordning och reda i statsfinanserna, öppenhet mot omvärlden och arbetslinjen var arvet från Reinfeldt och Borg som kronprinsessan inte hade för avsikt att överge.
Anna Kinberg Batra slog fast partiets linje:


CITAT: Vi säger inte go home, vi säger gå till jobbet 


På nymoderatska detsamma som att ställa hårdare krav på de som kommer till Sverige. De ska jobba, inte leva på bidrag. Att bekämpa "det nya utanförskapet" var det politiska projekt Anna Kinberg Batra ville samla partiet kring. Hennes moderatblå tråd.
I lokalen muttrades det från gammelmoderater och kommunalråd. Pakten som partiledningen slutit med statsminister Stefan Löfven (S) ett par veckor tidigare, som retfullt nog kom att förkortas DÖ, var ett lika obegripligt som oförsvarligt svek, både mot partiet och mot väljarna, menade man. Under åtta år skulle riksdagsledamöterna inte få rösta för sin egen politik utan bara se på när den rödgröna regeringen körde Sverige i fördärvet. Allt för att stänga ute Sverigedemokraterna. Obegripligt, tyckte Stockholms stads ordförande Henry Sténson och klev upp i talarstolen. 
- Jag tror att det är viktigt att vi vid ett senare tillfälle får möjligheten att tala om elefanten i rummet, det vill säga decemberöverenskommelsen.
Det skulle dröja tio månader innan överenskommelsen formellt föll och då på grund av Kristdemokraterna. 
Men i realiteten levde den kvar. Det gjorde även det interna missnöjet. DÖ-motståndarna tänkte inte ge sig förrän Anna Kinberg Batra sa att hon ville utnyttja högermajoriteten i riksdagen och fälla regeringen med stöd av Sverigedemokraterna



mellanrubrik: [ 19:e januari 2017 | tid ]

Riksdagsledamöterna hade inte en aning om vad det extra gruppmötet de kallats till på torsdagsmorgonen skulle handla om. Att det var något stort förstod de. Men att Moderaterna nu skulle plädera för en gemensam alliansbudget och inleda dialog med Sverigedemokraterna i riksdagens utskott överraskade.
Beskedet möttes av spridda applåder. Det var bara gruppledarna i utskotten som skruvade lite på sig, vad betydde det här för deras dagliga samarbete med allianskollegorna i C, L och KD? 
En av dem som applåderade var Cecilia Magnusson, ledamot sedan 1998, nu i kulturutskottet.
- Det var en lättnad. Det var vi som hade fått ta allt skyll när man undrade varför vi inte tog regeringsmakten, men vi var ju bakbundna av Centerpartiet och Liberalerna. Det hade börjat äta på oss, vi hade gått neråt, neråt, neråt i opinionen under lång tid, säger hon och fortsätter:
-Väljarna uppfattade det som att vi inte ville ha regeringsansvar, att vi inte menar vad vi säger. Det gröper ur förtroendet.
En dryg halvtimme efter gruppmötet hade alla redaktioner nyhetsflashat om moderatledarens helomvändning där hon pekade ut partiets nya riktning: 


CITAT: Vi måste göra mer för att visa att vi menar allvar. Det måste ske mer nu


{.video}
id:12963984
storlek:m
{}


I efterhand konstaterade medarbetarna att pressträffen inte blivit helt lyckad. Anna Kinberg Batra hade vecklat in sig i komplicerade resonemang om agerandet i finansutskottet och hon hade sagt för lite om vad hon ville göra med regeringsmakten.
-Hon borde tydligare ha förklarat vad regeringen gjorde som var dåligt och vad vi ville göra istället, säger en partikamrat.
Andra tyckte att hon sagt för mycket. 
- Man skulle bara ha sagt att vi Moderater nu kommer verka för en gemensam alliansbudget, vill sedan SD rösta på den så lever vi med det. Sedan skulle man satt punkt. Nu blev det väldigt rörigt, säger Ulf Berg, tidigare riksdagsledamot och ledamot i den valberedning som nominerade Anna Kinberg Batra.
Trovärdigheten var ett annat bekymmer. En dryg vecka tidigare hade Anna Kinberg Batra i DN med kraft sagt att en gemensam alliansbudget inte var aktuellt före valet. Sedan, plötsligt, var det den enda lösningen. Vem skulle då egentligen tro på Anna Kinberg Batra när hon sa att Moderaterna aldrig skulle budgetförhandla eller regeringssamarbeta med SD? 


{.video}
id:12963596
storlek:m
bildtext: I en intervju i SVT:s Agenda i augusti 2016 slog Anna Kinberg-Batra fast att SD är ett rasistiskt parti.
{}


Efter januaribeskedet har Moderaterna tappat drygt fyra procentenheter i SVT/Novus mätning och är nu mindre än Sverigedemokraterna. Flera kommunpolitiker har hoppat av i protest, senast Simon Härenstam, gruppledare på Gotland.
- För mig är det helt orimligt att man i ena meningen kan säga att det är ett rasistiskt parti för att i nästa steg säga att man vill ha hjälp av dem för att bilda regering, det är inte ett statsmannamässigt och trovärdigt sätt att bilda en stabil och långsiktig regering för Sverige, och det är precis det som Sverige behöver, sa han till SVT i förra veckan. 
mellanrubrik: LÄS MER: [Moderat gruppledare hoppar av i protest | http://www.svt.se/nyheter/lokalt/ost/m-s-gruppledare-pa-gotland-avgar ]

luft:100

{.bild}
fil: m-krisen-bakom-kulisserna/AKB_AKESSON.jpg
storlek: wide
bildtext: Anna Kinberg Batra hälsar på Sverigedemokraternas partiledare Jimmie Åkesson under årets första partiledardebatt i riksdagen den 11 januari.
foto: Fredrik Sandberg/TT
{}


mellanrubrik: Hård intern kritik

Närmandet till Sverigedemokraterna har fått partiet att rasa. Men bekymren började inte där. 
De folkvalda moderater som i dag oroas över om de kommer få behålla jobbet efter valet har en annan förklaring. Bristen på en sammanhållen politik.
De senaste veckorna har moderat efter moderat kritiserat partiledningen för att göra för många plötsliga utspel i syfte att nå kortsiktiga opinionsframgångar - "popcorn-politik" har det kallats, ett begrepp som myntades av Håkan Juholt när Mona Sahlin var partiledare för Socialdemokraterna. 
- Det finns inget program, allt är bara lösryckta förslag i populistisk iver att vinna kortsiktiga poänger , säger en stockholmsmoderat. 
En annan moderat är lika vass i sin kritik:

CITAT: Anna Kinberg Batra och Tomas Tobé gör inget annat än läser opinionsmätningar hela dagarna, det är förödande

Kritiken är knappast unik för Moderaterna. I en tid då reaktiva utspel snabbt betalar sig i stora rubriker i ett allt hetsigare nyhetsflöde är det lätt att få för sig att det är så man vinner väljare. Men i själva verket riskerar de många utspelen att göra väljarna osäkra på vad partiet egentligen vill. 
- Vi vet inte vilken den breda gemensamma visionen för Moderaterna är just nu. Vi säger att vi vill fälla regeringen men ingen vet vad vi vill göra istället, säger en riksdagsledamot. 
Lars-Ingvar Ljungman, ordförande i Skåne, partiets största distrikt, håller med.
- Jag noterar att vi gör många utspel i olika frågor när vi istället borde berätta om vårt Sverige, hur vi vill att Sverige ska se ut, säger han. 
En del menar att det beror på ledarskapet. Anna Kinberg Batra omger sig med en homogen grupp unga medarbetare som aldrig prövats i ett val. Var är de erfarna nationalekonomerna som kan räkna och juristerna som kan nagelfara de politiska idéerna frågar sig kritikerna. Vågar hon inte omge sig med nejsägare?
- Hon har ett enormt kontrollbehov och har svårt att delegera. Hon är inne i detaljerna för mycket och klarar inte av att göra en större omvärldsanalys, säger en partikamrat. 
En annan kritiserar kommunikationen utåt:


CITAT: Det har varit otroligt lågt i tak


{.bild}
fil: m-krisen-bakom-kulisserna/AKB4_POLISEN.jpg
storlek: lwide
bildtext: Anna Kinberg Batra besöker polisen i Rosengård i Malmö 30 januari 2017.
foto: Björn Lindgren / TT
{}


Partiledningen menar att de visst har ett politiskt projekt, sin moderatblå tråd. Den är densamma som när Anna Kinberg Batra valdes och densamma som i Almedalen 2015 när man presenterade nio miljarder i skattesänkningar för de med låga inkomster, det ["första jobbet"| http://www.svt.se/nyheter/inrikes/m-vill-satsa-10-miljarder-pa-fler-i-jobb ]. 
Och en arbetslinje som riktas mot utrikesfödda, snarare än förtidspensionärer som 2006, passar dessutom utmärkt i en valrörelse där integrationen kommer bli en av huvudfrågorna, menar man.
Till det vill man lägga en vässad skolpolitik och ökad trygghet bland annat med fler poliser, ny polischef och zonförbud.

rubrik5: LÄS MER: [Anna Kinberg Batra (M): ”Inför zonförbud i Sverige” | http://www.svt.se/nyheter/inrikes/anna-kinberg-batra-m-infor-zonforbud-i-sverige]


Men i ett parti där förnyelse under lång tid utgjorde kärnan i det politiska projektet, är kraven högt ställda. 
Benjamin Dousa, ordförande för ungdomsförbundet MUF, har inget emot den utstakade linjen. Men de förslag partiledningen lagt svarar inte upp mot de problem de beskriver.
- Vi säger att en miljon kommer leva i bidragsberoende 2020 och att vi behöver 150 000 nya, enkla jobb men vår politik löser inte det. Det är för mycket småkrafs och inte långtgående, rejäla reformer, säger han. 
Riksdagsledamoten Niklas Wykman, som ledde den reformgrupp partiledningen tillsatte i december 2015, är inne på samma linje.
- Vi har fortsatt som om vi var i regeringsställning. Vi förlorade valet rejält men ställde inte tillräckligt snabbt om till att vara samhällskritiska och leverera begripliga alternativ till regeringens politik, säger han och fortsätter:
- Med den arbetsrätt vi har, med den beskattning vi har och med alla de regleringar vi har kommer vi inte åt det här nya utanförskapet.

{.iframe}
src: http://pejl.svt.se/novus-opinion-diagram/samtliga.html
  storlek:l
height:470px
bildtext: Så här har partiernas väljarstöd sett ut de senaste åren enligt Novus väljarbarometer. Moderaternas väljarstöd har gått stadigt neråt det senaste halvåret.
credit: källa: Novus
{}

luft:100

I Stockholm, partiets viktigaste fäste, har väljarflykten varit störst, tolv procentenheter på ett år. Det är också här som kritiken varit hårdast. Men när Anna Kinberg Batra för ett par veckor sedan hade möte med kommunal- och landstingsråden uppfattades hon som övertygande. 
- Det finns en tanke om hur den ekonomiska politiken ska hänga ihop med våra värderingar och hur man kopplar ihop det med trygghetsfrågorna. Arbetslinjen, ett tryggt samhälle och hur man finansierar välfärden genom fler i jobb. Det kändes ganska mycket som när Anders Borg pratade ekonomi, säger Pehr Granfalk, kommunalråd i Solna. 


{.bild}
fil: m-krisen-bakom-kulisserna/AKB_REINFELDT1.jpg
storlek: wide
bildtext: Fredrik Reinfeldt gratulerar Anna Kinberg Batra efter hennes tal på Moderaternas partistämma i oktober 2015
foto: Fredrik Karlsson / TT 
{}


mellanrubrik: [ 10:e mars 2007 | tid ]

"Förändra er eller dö" var Fredrik Reinfeldts uppfordrande uppmaning till partikamraterna på kommunala rikskonferensen i Örebro. Då var det få som anade hur svårt han själv skulle ha att leva upp till den devisen under sina sista fyra år som statsminister. 
Men den nymoderata strategin - att göra upp med gamla sanningar och ta avstånd från sin företrädare - har Anna Kinberg Batra försökt ta efter.
Försvaret är inte längre ett särintresse utan måste stärkas, ett Nato-medlemskap brådskar, oavsett vad Socialdemokraterna tycker och de svenska värderingarna ska försvaras - i kontrast till Fredrik Reinfeldt som slog fast att "ursvenskt är bara barbariet". 
Men den enda riktiga förnyelse som Moderaterna levererat under Anna Kinberg Batra är migrationspolitiken. Från öppna hjärtan till stängda gränser. Tillfälliga uppehållstillstånd, hårdare försörjningskrav för anhöriginvandring, direktavvisning vid Sveriges gräns och en "tillfällig flyktingpaus".
Kontrasten är skarp mot Fredrik Reinfeldts tal om öppna hjärtan.
 

{.video}
id:12965532
storlek:m
bildtext: I sitt sommartal den 16 augusti 2014 vädjade Fredrik Reinfeldt till svenskarna att "öppna sina hjärtan" för de flyktingar som kom till Sverige.
{}


När partistämman i oktober 2015 röstade för den hårdare linjen med siffrorna 172-31 ansågs Anna Kinberg Batra ha hittat en egen profil för partiet - de nygamla Moderaterna. Begreppet "nya Moderaterna" använde hon inte alls, även om det fortfarande fanns med i partiloggan. 
Problemet var bara att sex veckor senare - den 24 november 2015 - blev mycket av Moderaternas skärpningar även den rödgröna regeringens politik. Strategin att driva regeringen framför sig genom att vara hårdare var inte längre en självklar röstmagnet.
Till en början såg det ändå ut att fungera. Gapet mellan Sverigedemokraterna och Moderaterna ökade och i slutet av maj 2016 var Moderaterna största parti med nära 28 procent av väljarna bakom sig i Novus mätning, tio procentenheter större än SD.
- Vi har en stor potential hos Sverigedemokraterna enligt de mätningar som vi har studerat och det handlar ju om att många av de väljarna nu tycker att vi har tagit tag i invandringsfrågan, [förklarade partisekreteraren Tomas Tobé för SVT | http://www.svt.se/nyheter/inrikes/sa-ska-m-locka-valjare-fran-sd ].
Att målet var att locka tillbaka väljare från Sverigedemokraterna var ingenting man hymlade med - tvärtom. Och de som var kritiska tystnade i takt med opinionsframgångarna. 

mellanrubrik: Lyckades inte övertyga väljarna

Men snart började det vända neråt igen. Och återgången från Sverigedemokraterna kom av sig.
Partiledningens slutsats var att väljarna nog ändå inte trodde att man menade allvar med omläggningen av migrationspolitiken. Alla visste ju att Anna Kinberg Batra en gång varit för fri invandring, även om det var femton år sedan. I en [debattartikel i Aftonbladet | http://www.aftonbladet.se/debatt/a/R0zM8/darfor-har-jag-andrat-mig-om-invandringen | target:ab ] gjorde hon än en gång avbön för den liberala flyktingpolitiken under Fredrik Reinfeldt och försäkrade att hennes omsvängning visst var på riktigt:
"Det finns de som tror att jag har omprövat av taktiska skäl. Andra tror att jag har ändrat mig tillfälligt. Båda har fel. Jag vill inte tillbaka till den gamla politiken. Den var inte hållbar."
Samtidigt som partiledningen tog i från tårna nådde Centerpartiet nya toppnivåer. 
Att partiets migrationspolitik nu var nästan lika hård som Sverigedemokraternas räckte inte heller för de partikamrater som ville att man tog över regeringsmakten med SD:s hjälp.


{.bild}
fil: m-krisen-bakom-kulisserna/partiledarfortroende2.png
storlek: wide
bildtext: Partiledarna med högst förtroende
{}

Det var inte bara kraven på ständig förnyelse som Anna Kinberg Batra ärvde av Fredrik Reinfeldt. Till den hörde bristen på en tydlig ideologisk linje.
Reinfeldt lyckades göra Moderaterna till ett brett parti där allmänintresset skulle gå före särintresset. Gamla moderata käpphästar som ett begränsat välfärdsåtagande, slopad värnskatt och uppluckrad arbetsrätt offrades för att locka LO-väljare. 
Det viktigaste var att lyssna på väljarna och det väljarna ville ha, skulle väljarna få. Ett slags "blanka papprets-politik" utan ideologiska hinder. Polisen, försvaret, inga kor var heliga när man ville matcha Socialdemokraternas satsningar på vård, skola, omsorg.
-Det finns de som säger att det behövs visioner. Jag vill varna för det, sa Fredrik Reinfeldt på partistämman i Örebro 2011 när partiet skulle anta ett nytt idéprogram.
Så länge det gick bra knöt de Moderater som ogillade trianguleringen av Socialdemokraternas politik näven i fickan. Den interna politiska debatten trycktes effektivt tillbaka. 
"Under regeringsåren brände man den idémässiga marken. Men svedjebruk är inte en lämplig metod för partiskötsel. Hanterar man idéer, människor och väljarrelationer som alla behöver en långsiktig omsorg, är det dumt att sätta eld på fundamenten" skrev [ Svenska Dagbladets politiska chefredaktör Tove Lifvendahl | https://www.svd.se/inga-genvagar-framat-for-m | target:svd ]. 
Det är arvet i en tid där värderingarna är viktigare än på länge i svensk politik. 

mellanrubrik: Otydlig ideologisk övertygelse

Anna Kinberg Batra har fört Moderaterna i konservativ riktning i migrationspolitiken men vilken ideologisk övertygelse som driver henne har inte varit alldeles uppenbart. Redan innan hon nominerades till partiledare ansågs det vara hennes största svaghet. Vad ville hon egentligen?
Vännerna menar att hon är en liberal som anpassat sig till verkligheten, precis som Fredrik Reinfeldt.
-Jag är möjligen mer liberal än någon annan moderat, sa hon när hon kom in i riksdagen som ersättare 2000.
På hösten 2014 omfamnade hon liberalkonservatismen.
- Det är en bra blandning. Vi har ordning och reda i botten, att inte förändra saker alldeles för fort och sedan människans frihet i centrum. Båda behövs, sa hon till SVT.
Men liberalkonservatismen är en knepig ideologi när värderingsstriden står mellan liberala globalister och konservativa nationalister som i dag. 
Det är således inte en helt okomplicerad kris Moderaterna är mitt uppe i. Ett parti som triangulerade bort gamla principer, en partiledare med oklar politisk övertygelse och en ideologi med inbyggda motsättningar. Sammantaget bidrar det till bilden av att Moderaterna under Anna Kinberg Batra mest följer opinionen och bara ägnar sig åt utspel och taktik. 
Och irritationen växer. Både bland de gammelmoderater som ser ett starkt försvar och stora skattesänkningar som meningen med föreningen och de Reinfeldtmoderater som varken kan acceptera att flyktingar ska direktavvisas vid gränsen eller närmandet till SD.

{.bild}
fil: m-krisen-bakom-kulisserna/AKB_TOBE_WYKMAN.jpg
storlek: wide
bildtext: Niklas Wykman, till höger, tillsammans med partisekreteraren Tomas Tobé. Wykman, tidigare partiets skattepolitiska talesperson, efterlyser mer långtgående politiska förslag.
foto: Yvonne Åsell / SvD / TT /
{}

mellanrubrik: Knivarna slipas

Som alltid när det går dåligt för ett parti skyller man på kommunikationen. "Politiken är bra, vi har bara varit för dåliga på att berätta om den." Så låter det även i Moderaterna just nu. 
-Man får inte reducera fundamentala behov i samhället till att låta som floskler eller kampanjuttryck. Man kan inte ägna sig åt trixande med slogans, säger riksdagsledamoten Niklas Wykman. 
En annan återkommande slutsats i partier på fallrepet är att någon måste gå. Om bara partiledaren visar handlingskraft och gör ett "bondeoffer" kan stormen bedarra. Den som det skvallrats om är partisekreteraren Tomas Tobé. Även gruppledaren i riksdagen Jessica Polfjärd nämns.
- Det skulle skicka en väldigt tydlig signal om handlingskraft och ledarförmåga. Hade det här varit Socialdemokraterna hade partisekreteraren redan fått gå, säger en kommunpolitiker. 
Andra pekar ut den rättspolitiska talespersonen Beatrice Ask. Det går inte att förnya sig i trygghetsfrågorna med en talesperson som varit justitieminister i åtta år, menar man. 
Att Anna Kinberg Batra själv skulle tvingas bort är det dock få som trott.
Skvallret om efterträdare har trots det pågått länge. Elisabeth Svantesson nämns - "hon är energisk men vad uträttade hon egentligen som arbetsmarknadsminister?". Ulf Kristersson finns med i spekulationerna även denna gång - "politiskt slipad men han är ju så lat, för övrigt vill han inte".
I slutändan hänger det som alltid på opinionssiffrorna. Ramlar Moderaterna ner under femton procent kommer knivarna att slipas.
- När någon väl säger att de inte har förtroende för henne så kommer det gå fort, säger en kommunpolitiker. 

Anna Kinberg Batra prövades aldrig när hon valdes, hon var den enda kandidaten när konkurrenterna gjorde sig omöjliga eller tackade nej. Det är nu hon går igenom sin svåraste prövning. Enligt vännerna är hon som bäst när det stormar som mest. 

{.bild}
fil: m-krisen-bakom-kulisserna/AKB_ALMEDALEN.jpg
storlek: wide
bildtext: Moderatledaren får blommor efter sitt tal i Almedalen under politikerveckan 2017.
foto: Henrik Montgomery/TT 
{}


luft:100

rubrik5: Elisabeth Marmorstein
luft: -40
rubrik5: Politikreporter
luft: -50
[elisabeth.marmorstein@svt.se | mailto:elisabeth.marmorstein@svt.se ]



{.sharebuttons}
title:DOKUMENT: Anna Kinberg Batras svåraste prövning
url:http://pejl.svt.se/m-krisen-bakom-kulisserna/
{}


{.fakta}
[.+content]
mellanrubrik: Partiledarens förtroendekärna
Mycket stort förtroende bland de egna väljarna dec 2016
[Anna Kinberg Batra] (M) 17%
[Annie Lööf] (c) 38%
[Stefan Löfven] (S) 29%

text:Källa: Sifo
[]
{}

{.fakta}
[.+content]
mellanrubrik: Moderaternas partiledning
[Anna Kinberg Batra] partiordförande
[Peter Danielsson] vice partiordförande, kommunalråd Helsingborg.
[Elisabeth Svantesson] andre vice ordförande, arbetsmarknadspolitisk talesperson.
[Tomas Tobé] partisekreterare
[Jessica Polfjärd] gruppledare i riksdagen
[Ulf Kristersson] ekonomisk-politisk talesperson
[Linda Norberg] presschef
[Johan Andréasson] stabschef.
[]
{}

{.fakta}
[.+content]
mellanrubrik: Decemberöverenskommelsen
[27 december 2014 - 9 oktober 2015.]
Den statsministerkandidat som representerar största partiblock släpps fram vid en omröstning i riksdagen. Övriga partier bakom överenskommelsen lägger ner sina röster.
En minoritetsregering ska få igenom sin budget. Om det finns en risk att regeringens budget faller skall övriga partier bakom överenskommelsen avstå från att rösta.
Att bryta ut delar ur budgeten ska inte vara möjliga.
Partierna bakom överenskommelsen ska samarbeta om försvar och säkerhet, pensioner och energi.
Överenskommelsen skulle gälla till och med valdagen 2022.

[]
{}


luft:100




[]
`;

export default article;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/m-krisen-bakom-kulisserna.js
 **/